// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"MultiLineEllipsis_firstLine__IIFOa","singleLine":"MultiLineEllipsis_singleLine__11r3B","lastLine":"MultiLineEllipsis_lastLine__3d9lx"};